import { IOption } from '@shared/interfaces/selectable-options.interfaces';

export const cmmsEntityCategories = [
	{ key: null, value: 'category_none' },
	{ key: 'AUTOMATION', value: 'categories_automation' },
	{ key: 'BUILDING', value: 'categories_building' },
	{ key: 'ELECTRICAL', value: 'categories_electrical' },
	{ key: 'FIRE', value: 'categories_fire' },
	{ key: 'HEATING_AND_COOLING', value: 'categories_heating_and_cooling' },
	{ key: 'OUTDOOR', value: 'categories_outdoor' },
	{ key: 'PIPING', value: 'categories_piping' },
	{ key: 'SAFETY', value: 'categories_safety' },
	{ key: 'SANITARY', value: 'categories_sanitary' },
	{ key: 'VENTILATION', value: 'categories_ventilation' },
];

// TODO this is temporary, until BE provides the options for multiselect filter
export function getFilterCategories(): IOption[] {
	const options = cmmsEntityCategories.map(category => {
		return {
			id: category.key,
			name: category.value,
		};
	});
	return options;
}
